import React from 'react';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
export const MasivoDialog = ({ handleSaveMasivo, isMasivoDialogOpen, masivoData, propietarios, saving, setIsMasivoDialogOpen, setMasivoData }) => {
  return (
      <Dialog open={isMasivoDialogOpen} onOpenChange={setIsMasivoDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Alta Masiva de Unidades</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSaveMasivo} className="space-y-4">
            <div className="space-y-2">
              <Label>Propietario *</Label>
              <Select value={masivoData.propietario_id} onValueChange={(v) => setMasivoData({...masivoData, propietario_id: v})}>
                <SelectTrigger><SelectValue placeholder="Seleccionar" /></SelectTrigger>
                <SelectContent>
                  {propietarios.map((p) => (
                    <SelectItem key={p.propietario_id} value={p.propietario_id}>{p.nombre_razon_social}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Tipo *</Label>
              <Select value={masivoData.tipo} onValueChange={(v) => setMasivoData({...masivoData, tipo: v})}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="oficina">Oficina</SelectItem>
                  <SelectItem value="local">Local</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Nombres *</Label>
              <Textarea value={masivoData.nombres} onChange={(e) => setMasivoData({...masivoData, nombres: e.target.value})} placeholder="Un nombre por línea:&#10;Oficina 1A&#10;Oficina 1B" rows={6} />
              <p className="text-xs text-slate-500">Un nombre de unidad por línea</p>
            </div>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setIsMasivoDialogOpen(false)}>Cancelar</Button>
              <Button type="submit" disabled={saving}>{saving ? 'Creando...' : 'Crear Unidades'}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
  );
};
